import { z } from 'zod';

// Get price
const DiscountDetailsSchema = z.object({
  amount: z.number(),
  success: z.boolean(),
  message: z.string(),
  code: z.string().optional(),
  duration: z.enum(['once', 'forever']).optional(),
  copyLimitScope: z.enum(['item', 'order']).optional(),
  discountedCopies: z.number().optional(),
});

export const PricesSchema = z.object({
  startingPrice: z.number(),
  salePrice: z.number().nullable().optional(),
  copies: z.number(),
  subtotal: z.number(),
  discountDetails: DiscountDetailsSchema.nullable().optional(),
  totalPrice: z.number(),
  billingPeriodMonths: z.number().nullable().optional(),
});

export type GetPriceResponse = z.infer<typeof PricesSchema>;

export interface GetPriceRequest {
  productId: string;
  discountCode?: string;
  copies?: number;
  planId?: string;
}
